var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#6FBCF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60Z",
    fill: "#6FBCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3906 45.6094C41.3906 50.8125 36 53.9297 30 53.9297C24 53.9297 18.6094 50.8125 15.6094 45.6094C12.6094 40.4063 12.6094 34.1953 15.6094 28.9922L28.2656 7.05469C29.0391 5.71875 30.9609 5.71875 31.7344 7.05469L44.3906 28.9922C47.4141 34.1953 47.4141 40.4063 44.3906 45.6094ZM33.5625 17.4844L30.8672 12.7969C30.4922 12.1406 29.5078 12.1406 29.1328 12.7969L18.75 30.7969C16.8516 34.1016 16.4766 37.9219 17.6719 41.4375C17.7891 40.875 17.9766 40.2891 18.2109 39.7031C19.6406 36.0703 22.8984 33.2813 27.8672 31.4063C31.2891 30.1172 33.4688 28.1953 34.3359 25.7344C35.4609 22.5469 34.2656 19.0781 33.5625 17.4844ZM38.1797 25.4531L41.25 30.7969C43.5938 34.875 43.5938 39.7266 41.25 43.8047C38.9063 47.8828 34.6875 50.2969 30 50.2969C26.8828 50.2969 23.9766 49.2188 21.6797 47.3203C21.375 46.5703 20.4609 43.8281 21.6094 40.9922C22.6641 38.3672 25.1953 36.2813 29.1562 34.7813C33.6094 33.0938 36.5156 30.4453 37.7812 26.9297C37.9453 26.4375 38.0625 25.9453 38.1797 25.4531Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/Sui.558eab39f71586011d2bb84992044161.svg";
export { ForwardRef as ReactComponent };